import { getRangeValue, getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { EMetroTravelType } from '../../../../api-models/common/json_query';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'undergroundTime' as const;

export const undergroundTimeTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const travelType = getTermValue('only_foot')(jsonQuery);
    const travelTime = getRangeValue('foot_min')(jsonQuery)?.lte;

    if (!travelTime || !travelType) {
      return null;
    }

    const travelTimeText = `${travelTime} мин.`;
    const traveTypeText = `${travelType === EMetroTravelType.MapFoot ? 'пешком' : 'транспортом'}`;
    const label = `До метро ${travelTimeText} ${traveTypeText}`.trim();

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['foot_min', 'only_foot'])(jsonQuery),
};
